// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__DP5P9","pagination__transport":"Pagination_pagination__transport__OpM+R"};